import phoneIcon from "../assets/images/icons/Vector (13).svg";
import LegacyActivityLayout from "../components/LegacyActivityLayout";
import { useTranslation } from "../components/Localization";

export default function LegacyPhoneTaskPage() {
  const { t } = useTranslation();
  return <LegacyActivityLayout taskKey="phone" step={3} backTo="/mariaffiek/menekules/jatek" nextTo="/mariaffiek/eredmeny">
    <button className="task-icon-button legacy-phone" aria-label={t("accessibility.phonePickup")}><img src={phoneIcon} alt="" /></button>
  </LegacyActivityLayout>;
}
